module.exports = __webpack_public_path__ + "static/11-gator-zoom-28102487413c94747c261c0b10e33462.jpg";